import makeStyles from "utils/makeStyles";

export default makeStyles((theme) => ({
  wrapper: {
    backgroundColor: "white",
    borderRadius: "10px",
  },
  header: {
    padding: "10px 20px",
    background: "#F7F8FA",
  },
  headerToolbar: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  toolbar: {
    padding: "0px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  crudButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  content: {
    padding: "10px 20px",
  },
}));
